module.exports = __webpack_public_path__ + "static/media/KI.81ad67a4.png";